import styled, { css } from "styled-components/macro";


export const FacebookLoginButton =styled.iframe`
    border:none;
`